const CollectionDescription = {};

CollectionDescription.domready = (el) => {
  document.addEventListener('DOMContentLoaded', () => {
    el();
  });
};

CollectionDescription.queryCollectionDescriptions = () => {
  const collectionDescriptionSections = document.querySelectorAll('.collection-description');
  if (collectionDescriptionSections.length === 0 ) return;
  collectionDescriptionSections.forEach((section) => {
    CollectionDescription.readMoreAdjustment(section);
    CollectionDescription.windowResize(section);
  });
};

CollectionDescription.readMoreAdjustment = (section) => {
  let descriptionTotalHeight = 0;
  const descriptionContainer = section.querySelector('.collection-description__inner');
  if (!descriptionContainer) return;
  const descriptionContents = descriptionContainer.querySelectorAll('div');
  if (descriptionContents.length === 0) return;
  descriptionContents.forEach((content) => {
    descriptionTotalHeight += content.offsetHeight;
  });
  const readMoreButtonContainer = section.querySelector('.read-more-trigger__container');
  if (!readMoreButtonContainer) return;
  if (descriptionTotalHeight < 300 ) {
    readMoreButtonContainer.style.display = 'none';
    descriptionContainer.style.height = 'auto';
  } else {
    readMoreButtonContainer.style.display = 'flex';
    descriptionContainer.style.height = '300px';
  };
};

CollectionDescription.windowResize = (section) => {
  window.addEventListener('resize', () => CollectionDescription.readMoreAdjustment(section));
};

CollectionDescription.domready(CollectionDescription.queryCollectionDescriptions);